// ÐÐµÑÐµÐ²Ð¾ Ð¿ÑÐ°Ð¹ÑÐ°: ÑÐ¸ÑÑÑÐµ ÑÑÐ½ÐºÑÐ¸Ð¸ Ð±ÐµÐ· React.
//
// ÐÐ° ÑÐµÑÐ²ÐµÑÐµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð»ÐµÐ¶Ð°Ñ Ð¿Ð»Ð¾ÑÐºÐ¸Ð¼ ÑÐ¿Ð¸ÑÐºÐ¾Ð¼ (price_rules), Ð´ÐµÑÐµÐ²Ð¾ â ÑÐ¾Ð»ÑÐºÐ¾
// Ð¿ÑÐµÐ´ÑÑÐ°Ð²Ð»ÐµÐ½Ð¸Ðµ. Ð¤Ð¾ÑÐ¼Ð° Ð´ÐµÑÐµÐ²Ð° Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾ ÐÐ ÑÑÐ°Ð½Ð¸ÑÑÑ: Ð¾Ð½Ð° Ð²Ð¾ÑÑÑÐ°Ð½Ð°Ð²Ð»Ð¸Ð²Ð°ÐµÑÑÑ Ð¸Ð·
// ÑÐ°Ð¼Ð¸Ñ Ð¿ÑÐ°Ð²Ð¸Ð». Ð£Ð·ÐµÐ» ÑÑÐ¸ÑÐ°ÐµÑÑÑ ÑÐ°Ð·Ð±Ð¸ÑÑÐ¼ Ð¿Ð¾ Ð°ÑÑÐ¸Ð±ÑÑÑ, ÐµÑÐ»Ð¸ ÐµÑÑÑ Ð¿ÑÐ°Ð²Ð¸Ð»Ð°, ÐºÐ¾ÑÐ¾ÑÑÐµ
// ÑÑÐ¾ÑÐ½ÑÑÑ ÐµÐ³Ð¾ ÑÑÐ¸Ð¼ Ð°ÑÑÐ¸Ð±ÑÑÐ¾Ð¼. Ð¡Ð»ÐµÐ´ÑÑÐ²Ð¸Ðµ, Ð¾ ÐºÐ¾ÑÐ¾ÑÐ¾Ð¼ ÑÑÐ¾Ð¸Ñ Ð·Ð½Ð°ÑÑ: ÑÐ°Ð·Ð±Ð¸ÐµÐ½Ð¸Ðµ, Ð¿Ð¾Ð´
// ÐºÐ¾ÑÐ¾ÑÑÐ¼ Ð½Ðµ Ð²Ð¿Ð¸ÑÐ°Ð»Ð¸ Ð½Ð¸ Ð¾Ð´Ð½Ð¾Ð¹ ÑÐµÐ½Ñ, Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð¸ÑÑÐµÐ·Ð½ÐµÑ â Ð¾Ð½Ð¾ Ð¸ Ð½Ðµ Ð½ÐµÑÑÑ
// Ð½Ð¸ÐºÐ°ÐºÐ¾Ð¹ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ð¸.
//
// Ð¡ÐµÐ¼Ð°Ð½ÑÐ¸ÐºÐ° Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð² Ð¿ÑÐ°Ð²Ð¸Ð»Ðµ (ÑÐ° Ð¶Ðµ, ÑÑÐ¾ Ð½Ð° Ð±ÑÐºÐµ â docs/price-lists.md):
//   null              â Ð°ÑÑÐ¸Ð±ÑÑ Ð½Ðµ ÑÑÐ°ÑÑÐ²ÑÐµÑ, Â«Ð»ÑÐ±Ð¾Ð¹Â»
//   0 / Ð¿ÑÑÑÐ°Ñ ÑÑÑÐ¾ÐºÐ° â Ð°ÑÑÐ¸Ð±ÑÑ Ñ Ð¼Ð°ÑÐ¸Ð½Ñ Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½, Ð²ÐµÑÐºÐ° Â«Ð½Ðµ ÑÐºÐ°Ð·Ð°Ð½Â»
//   Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ          â ÑÐ¾ÑÐ½Ð¾Ðµ ÑÐ¾Ð²Ð¿Ð°Ð´ÐµÐ½Ð¸Ðµ

// ÐÐ¾ÑÑÐ´Ð¾Ðº ÑÐ¾Ð»ÑÐºÐ¾ Ð´Ð»Ñ ÑÐ°Ð·ÑÐµÑÐµÐ½Ð¸Ñ Ð½Ð¸ÑÑÐ¸Ñ Ð¿ÑÐ¸ Ð²Ð¾ÑÑÑÐ°Ð½Ð¾Ð²Ð»ÐµÐ½Ð¸Ð¸ Ð´ÐµÑÐµÐ²Ð°;
// ÑÐ°Ð·Ð±Ð¸Ð²Ð°ÑÑ Ð¼Ð¾Ð¶Ð½Ð¾ Ð² Ð»ÑÐ±Ð¾Ð¼ Ð¿Ð¾ÑÑÐ´ÐºÐµ
export const ATTRS = [
  { key: 'issueYear', title: 'Ð³Ð¾Ð´' },
  { key: 'complectationId', title: 'ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ' },
  { key: 'engineVolume', title: 'Ð¾Ð±ÑÑÐ¼' },
  { key: 'wdId', title: 'Ð¿ÑÐ¸Ð²Ð¾Ð´' },
];

const ATTR_KEYS = ATTRS.map((a) => a.key);

export const NOT_SET = 'Ð½Ðµ ÑÐºÐ°Ð·Ð°Ð½';

// Ð¢Ð¾Ñ Ð¶Ðµ ÑÐ°Ð·Ð±Ð¾Ñ, ÑÑÐ¾ Ð¸ Ð½Ð° Ð±ÑÐºÐµ (PriceListService.NormalizeEngineVolume): ÑÑÐ¾Ðº
// ÑÑÐ°Ð½Ð¸Ñ Ð¾Ð±ÑÑÐ¼ ÐºÐ°Ðº Ð¿Ð¾Ð¿Ð°Ð»Ð¾ â Â«1975Â», Â«2Â», Â«2,0Â», Â«1.4 TSIÂ». ÐÐµÐ· Ð½ÐµÐ³Ð¾ Ð²ÐµÑÐºÐ°,
// Ð·Ð°Ð²ÐµÐ´ÑÐ½Ð½Ð°Ñ Ð²ÑÑÑÐ½ÑÑ ÐºÐ°Ðº Â«2500Â», Ð½Ðµ ÑÐ¾Ð²Ð¿Ð°Ð»Ð° Ð±Ñ Ð½Ð¸ Ñ Ð¾Ð´Ð½Ð¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ð¾Ð¹ Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð°
// Â«Ð½ÐµÑ Ð² ÑÑÐ¾ÐºÐµÂ», ÑÐ¾ÑÑ Ð¼Ð°ÑÐ¸Ð½Ñ ÐµÑÑÑ â ÑÐ°ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÑÐ¾Ð´Ð¸Ð»Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ÑÐ»Ðµ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ
export const normalizeEngineVolume = (raw) => {
  if (raw == null || String(raw).trim() === '') return '';
  const m = String(raw).replace(',', '.').match(/\d+(\.\d+)?/);
  if (!m) return '';
  let v = Number(m[0]);
  if (!Number.isFinite(v) || v <= 0) return '';
  // ÑÐ¼Â³ Ð¿Ð¸ÑÑÑ ÑÐµÐ»ÑÐ¼ ÑÐ¸ÑÐ»Ð¾Ð¼ Ð¾Ñ 100 Ð¸ Ð²ÑÑÐµ â Ð¿ÐµÑÐµÐ²Ð¾Ð´Ð¸Ð¼ Ð² Ð»Ð¸ÑÑÑ
  if (v >= 100) v = Math.round((v / 1000) * 10) / 10;
  return v <= 0 ? '' : v.toFixed(1);
};

// ÐÑÑÐ¸Ð±ÑÑÑ, Ñ ÐºÐ¾ÑÐ¾ÑÑÑ Â«Ð½Ðµ Ð·Ð°Ð¿Ð¾Ð»Ð½ÐµÐ½Ð¾Â» ÐºÐ¾Ð´Ð¸ÑÑÐµÑÑÑ Ð½ÑÐ»ÑÐ¼, Ð° Ð½Ðµ Ð¿ÑÑÑÐ¾Ð¹ ÑÑÑÐ¾ÐºÐ¾Ð¹
const NUMERIC_ATTRS = ['complectationId', 'wdId'];

const isUnset = (key, value) => (NUMERIC_ATTRS.includes(key) ? !value : !String(value ?? '').length);

// ÐÐµÑÐºÐ° ÑÑÐ¾ÐºÐ° Ð¿Ð¾Ð´ÑÐ¾Ð´Ð¸Ñ ÑÐ·Ð»Ñ, ÐµÑÐ»Ð¸ ÑÐ¾Ð²Ð¿Ð°Ð»Ð¸ Ð²ÑÐµ Ð·Ð°ÑÐ¸ÐºÑÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ Ð°ÑÑÐ¸Ð±ÑÑÑ
export const groupMatches = (fixed, group) =>
  Object.keys(fixed).every((k) => String(group[k] ?? '') === String(fixed[k] ?? ''));

// ÐÑÐ°Ð²Ð¸Ð»Ð¾ â Ð¾Ð±ÑÐµÐºÑ ÑÐ¾Ð»ÑÐºÐ¾ Ð¸Ð· Ð·Ð°Ð´Ð°Ð½Ð½ÑÑ Ð°ÑÑÐ¸Ð±ÑÑÐ¾Ð² (null Ð¾ÑÐ±ÑÐ°ÑÑÐ²Ð°ÐµÐ¼: ÑÑÐ¾ Â«Ð»ÑÐ±Ð¾Ð¹Â»)
export const ruleFixed = (rule) => {
  const out = {};
  if (rule.modelId !== null && rule.modelId !== undefined) out.modelId = rule.modelId;
  ATTR_KEYS.forEach((k) => {
    if (rule[k] !== null && rule[k] !== undefined) out[k] = rule[k];
  });
  return out;
};

const sameFixed = (a, b) => {
  const ka = Object.keys(a);
  const kb = Object.keys(b);
  return ka.length === kb.length && ka.every((k) => String(a[k] ?? '') === String(b[k] ?? ''));
};

// ÐÑÐ°Ð²Ð¸Ð»Ð¾ ÑÑÐ¾ÑÐ½ÑÐµÑ ÑÐ·ÐµÐ»: ÑÐ¾Ð³Ð»Ð°ÑÐ¾Ð²Ð°Ð½Ð¾ Ð¿Ð¾ Ð²ÑÐµÐ¼ ÐµÐ³Ð¾ Ð°ÑÑÐ¸Ð±ÑÑÐ°Ð¼ Ð¸ Ð·Ð°Ð´Ð°ÑÑ ÑÑÐ¾-ÑÐ¾ ÑÐ²ÐµÑÑ
const extendsFixed = (ruleF, fixed) =>
  Object.keys(fixed).every((k) => String(ruleF[k] ?? '') === String(fixed[k] ?? '')) &&
  Object.keys(ruleF).length > Object.keys(fixed).length;

// ÐÐ¾ ÐºÐ°ÐºÐ¾Ð¼Ñ Ð°ÑÑÐ¸Ð±ÑÑÑ ÑÐ·ÐµÐ» Ð±ÑÐ» ÑÐ°Ð·Ð±Ð¸Ñ: ÑÐ¾Ñ, ÐºÐ¾ÑÐ¾ÑÑÐ¼ ÐµÐ³Ð¾ ÑÑÐ¾ÑÐ½ÑÐµÑ Ð±Ð¾Ð»ÑÑÐµ Ð²ÑÐµÐ³Ð¾ Ð¿ÑÐ°Ð²Ð¸Ð»
const splitAttrFor = (fixed, rules) => {
  const votes = {};
  rules.forEach((r) => {
    const rf = ruleFixed(r);
    if (!extendsFixed(rf, fixed)) return;
    Object.keys(rf)
      .filter((k) => !(k in fixed) && ATTR_KEYS.includes(k))
      .forEach((k) => {
        votes[k] = (votes[k] || 0) + 1;
      });
  });
  const best = Object.keys(votes).sort(
    (a, b) => votes[b] - votes[a] || ATTR_KEYS.indexOf(a) - ATTR_KEYS.indexOf(b)
  );
  return best[0] || null;
};

// ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ Ð²ÐµÑÐºÐ¸ Ð±ÐµÑÑÑÑÑ Ð¸Ð· ÑÑÐ¾ÐºÐ° Ð Ð¸Ð· Ð¿ÑÐ°Ð²Ð¸Ð».
//
// Ð¢Ð¾Ð»ÑÐºÐ¾ Ð¸Ð· ÑÑÐ¾ÐºÐ° Ð±ÑÐ»Ð¾ Ð½ÐµÐ»ÑÐ·Ñ: Ð¿ÑÐ¸ÐºÐ°Ð· ÑÐµÐ³ÑÐ»ÑÑÐ½Ð¾ Ð½Ð°Ð·ÑÐ²Ð°ÐµÑ Ð²Ð°ÑÐ¸Ð°Ð½Ñ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð²
// Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸ ÐµÑÑ Ð½ÐµÑ (Ð½Ð¾Ð²ÑÐ¹ Ð¿ÑÐ¸Ð²Ð¾Ð´, Ð½Ð¾Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ, ÑÐ»ÐµÐ´ÑÑÑÐ¸Ð¹ Ð¼Ð¾Ð´ÐµÐ»ÑÐ½ÑÐ¹ Ð³Ð¾Ð´).
// ÐÐ°Ð²ÐµÑÑÐ¸ Ð½Ð° Ð½ÐµÐ³Ð¾ ÑÐµÐ½Ñ Ð·Ð°ÑÐ°Ð½ÐµÐµ â ÐµÐ´Ð¸Ð½ÑÑÐ²ÐµÐ½Ð½ÑÐ¹ ÑÐ¿Ð¾ÑÐ¾Ð± Ð½Ðµ Ð´Ð°ÑÑ Ð¿ÑÐ¸ÐµÑÐ°Ð²ÑÐµÐ¹ Ð¼Ð°ÑÐ¸Ð½Ðµ
// Ð¼Ð¾Ð»ÑÐ° ÑÐ½Ð°ÑÐ»ÐµÐ´Ð¾Ð²Ð°ÑÑ ÑÐµÐ½Ñ ÑÐ¾Ð´Ð¸ÑÐµÐ»Ñ. Ð ÑÐ°Ð· Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ ÐµÑÑÑ, Ð²ÐµÑÐºÐ° Ð¾Ð±ÑÐ·Ð°Ð½Ð° Ð±ÑÑÑ Ð²Ð¸Ð´Ð½Ð°,
// Ð¸Ð½Ð°ÑÐµ ÑÐµÐ½Ð° ÑÐ¾ÑÑÐ°Ð½Ð¸Ð»Ð°ÑÑ Ð±Ñ, Ð½Ð¾ Ð¿ÑÐ¾Ð¿Ð°Ð»Ð° Ñ ÑÐºÑÐ°Ð½Ð°.
const distinctValues = (attr, groups, rules = [], fixed = {}) => {
  const seen = new Map();
  const blank = NUMERIC_ATTRS.includes(attr) ? 0 : '';
  const add = (v) => seen.set(String(v ?? ''), v ?? blank);

  groups.forEach((g) => add(g[attr]));
  rules.forEach((r) => {
    const rf = ruleFixed(r);
    if (!(attr in rf)) return;
    // Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð¿ÑÐ¸Ð½Ð°Ð´Ð»ÐµÐ¶Ð°ÑÑ ÑÑÐ¾Ð¹ Ð²ÐµÑÐºÐµ, Ð° Ð½Ðµ ÑÐ¾ÑÐµÐ´Ð½ÐµÐ¹
    if (!Object.keys(fixed).every((k) => String(rf[k] ?? '') === String(fixed[k] ?? ''))) return;
    add(rf[attr]);
  });

  // Â«Ð½Ðµ ÑÐºÐ°Ð·Ð°Ð½Â» Ð²ÑÐµÐ³Ð´Ð° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½Ð¸Ð¼ â ÑÑÐ¾ Ð½Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, Ð° Ð´ÑÑÐ° Ð² Ð´Ð°Ð½Ð½ÑÑ
  return [...seen.values()].sort((a, b) => {
    const ua = isUnset(attr, a);
    const ub = isUnset(attr, b);
    if (ua !== ub) return ua ? 1 : -1;
    return String(a).localeCompare(String(b), 'ru', { numeric: true });
  });
};

export const makeNode = (fixed, stock, rules) => {
  const groups = stock.filter((g) => groupMatches(fixed, g));
  const own = rules.find((r) => sameFixed(ruleFixed(r), fixed));
  const by = splitAttrFor(fixed, rules);
  return {
    fixed,
    by,
    price: own ? own.price : null,
    groups,
    kids: by
      ? distinctValues(by, groups, rules, fixed).map((v) =>
          makeNode({ ...fixed, [by]: v }, stock, rules)
        )
      : [],
  };
};

// ÐÐµÑÑÐ½Ð¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ Ð²ÑÐµÐ³Ð´Ð° Ð¼Ð¾Ð´ÐµÐ»Ñ: Ð¿ÑÐ¸ÐºÐ°Ð·Ñ Ð°Ð´ÑÐµÑÑÑÑ ÑÐµÐ½Ñ Ð½Ðµ Ð¼ÐµÐ»ÑÑÐµ Ð¼Ð¾Ð´ÐµÐ»Ð¸
export const buildTree = (stock, rules) =>
  distinctValues('modelId', stock, rules, {}).map((modelId) =>
    makeNode({ modelId }, stock, rules)
  );

export const splitNode = (node, attr, stock, rules) => ({
  ...node,
  by: attr,
  kids: distinctValues(attr, node.groups, rules, node.fixed).map((v) =>
    makeNode({ ...node.fixed, [attr]: v }, stock, rules)
  ),
});

// Ð ÑÑÐ½Ð°Ñ Ð²ÐµÑÐºÐ°: Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ, ÐºÐ¾ÑÐ¾ÑÐ¾Ð³Ð¾ Ð² ÑÑÐ¾ÐºÐµ ÐµÑÑ Ð½ÐµÑ, Ð½Ð¾ ÐºÐ¾ÑÐ¾ÑÐ¾Ðµ ÐµÑÑÑ Ð² Ð¿ÑÐ¸ÐºÐ°Ð·Ðµ.
// ÐÐ¾ÑÐ²Ð»ÑÐµÑÑÑ ÐºÐ°Ðº Ð¾Ð±ÑÑÐ½ÑÐ¹ ÑÐ·ÐµÐ» Ñ Ð½ÑÐ»ÑÐ¼ Ð¼Ð°ÑÐ¸Ð½ Ð¸ Ð¶Ð¸Ð²ÑÑ Ð´Ð¾ ÑÐµÑ Ð¿Ð¾Ñ, Ð¿Ð¾ÐºÐ° Ð² Ð½ÐµÐ¹ ÐµÑÑÑ
// ÑÐµÐ½Ð° â Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð±ÐµÐ· ÑÐµÐ½Ñ Ð½Ðµ ÑÐ¾ÑÑÐ°Ð½ÑÐµÑÑÑ Ð¸ Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð¸ÑÑÐµÐ·Ð½ÐµÑ ÑÐ°Ð¼Ð¾.
export const addBranch = (node, attr, value, stock, rules) => {
  const key = String(value ?? '');
  if (node.kids.some((k) => String(k.fixed[attr] ?? '') === key)) return node;
  const kid = makeNode({ ...node.fixed, [attr]: value }, stock, rules);
  return { ...node, by: attr, kids: [...node.kids, kid] };
};

export const collapseNode = (node) => ({ ...node, by: null, kids: [] });

// ÐÐ»ÑÑÐ¸ Ð²ÑÐµÑ Ð²ÐµÑÐ¾Ðº Ð¿Ð¾Ð´Ð´ÐµÑÐµÐ²Ð°, Ð²ÐºÐ»ÑÑÐ°Ñ ÑÐ°Ð¼Ñ. ÐÑÐ¶Ð½Ñ, ÑÑÐ¾Ð±Ñ ÐºÐ»Ð¸Ðº ÑÐ°ÑÐºÑÑÐ²Ð°Ð» Ð²ÐµÑÐºÑ
// ÑÐµÐ»Ð¸ÐºÐ¾Ð¼, Ð° Ð½Ðµ Ð¿Ð¾ ÑÑÐ¾Ð²Ð½Ñ Ð·Ð° ÑÐ°Ð·: ÑÐµÐ½Ð° Ð½ÐµÑÐµÐ´ÐºÐ¾ Ð»ÐµÐ¶Ð¸Ñ Ð½Ð° ÑÑÐµÑÑÐµÐ¼ ÑÑÐ¾Ð²Ð½Ðµ
// (Carnival â ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ â Ð¾Ð±ÑÑÐ¼), Ð¸ Ð´Ð¾ Ð½ÐµÑ Ð¿ÑÐ¸ÑÐ¾Ð´Ð¸Ð»Ð¾ÑÑ ÑÑÐ»ÐºÐ°ÑÑ ÑÑÐ¸Ð¶Ð´Ñ,
// ÐºÐ°Ð¶Ð´ÑÐ¹ ÑÐ°Ð· Ð³Ð»ÑÐ´Ñ Ð½Ð° ÑÑÑÐ¾ÐºÐ¸ Ñ Ð¿ÑÐ¾ÑÐµÑÐºÐ¾Ð¼ Ð²Ð¼ÐµÑÑÐ¾ ÑÐ¸ÑÑÑ
export const subtreePaths = (node) => {
  const out = [];
  const walk = (n) => {
    out.push(JSON.stringify(n.fixed));
    n.kids.forEach(walk);
  };
  walk(node);
  return out;
};

// Ð¡ÐºÐ¾Ð»ÑÐºÐ¾ ÑÐµÐ½ Ð¿Ð¾ÑÐµÑÑÐµÑÑÑ Ð¿ÑÐ¸ ÑÐ²Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ð½Ð¸Ð¸ â Ð½Ð° ÑÑÐ¾ ÑÐ¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ
export const pricedInside = (node) =>
  node.kids.reduce((sum, k) => sum + (k.price != null ? 1 : 0) + pricedInside(k), 0);

// ÐÐµÑÐµÐ²Ð¾ â Ð¿Ð»Ð¾ÑÐºÐ¸Ð¹ Ð½Ð°Ð±Ð¾Ñ Ð¿ÑÐ°Ð²Ð¸Ð». Ð£Ð·Ð»Ñ Ð±ÐµÐ· ÑÐµÐ½Ñ Ð½Ðµ ÑÑÐ°Ð½ÑÑÑÑ Ð²Ð¾Ð²ÑÐµ.
export const treeToRules = (roots) => {
  const out = [];
  const walk = (n) => {
    if (n.price != null) {
      // Ð§Ð¸ÑÐ»Ð¾Ð²ÑÐµ Ð°ÑÑÐ¸Ð±ÑÑÑ Ð¿ÑÐ¸Ð²Ð¾Ð´Ð¸Ð¼ ÑÐ²Ð½Ð¾: Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð²ÐµÑÐ¾Ðº Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ð¸Ð· ÑÑÐ¾ÐºÐ° Ð¸ Ð¼Ð¾Ð³ÑÑ
      // Ð¾ÐºÐ°Ð·Ð°ÑÑÑÑ ÑÑÑÐ¾ÐºÐ°Ð¼Ð¸, Ð° Ð±ÑÐº Ð¶Ð´ÑÑ int? â Ð¸Ð½Ð°ÑÐµ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ Ð¿Ð°Ð´Ð°Ð»Ð¾ Ð±Ñ Ð² 400
      const num = (v) => (v ? Number(v) : 0);
      out.push({
        modelId: n.fixed.modelId ? Number(n.fixed.modelId) : null,
        issueYear: 'issueYear' in n.fixed ? String(n.fixed.issueYear ?? '') : null,
        complectationId: 'complectationId' in n.fixed ? num(n.fixed.complectationId) : null,
        engineVolume: 'engineVolume' in n.fixed ? String(n.fixed.engineVolume ?? '') : null,
        wdId: 'wdId' in n.fixed ? num(n.fixed.wdId) : null,
        price: n.price,
      });
    }
    n.kids.forEach(walk);
  };
  roots.forEach(walk);
  return out;
};

// ÐÑÐ°Ð²Ð¸Ð»Ð°, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð´ÐµÑÐµÐ²Ð¾ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Ð½Ðµ Ð¼Ð¾Ð¶ÐµÑ Ð² Ð¿ÑÐ¸Ð½ÑÐ¸Ð¿Ðµ: Ð²ÐµÑÑÐ½Ð¸Ð¹ ÑÑÐ¾Ð²ÐµÐ½Ñ â Ð²ÑÐµÐ³Ð´Ð°
// Ð¼Ð¾Ð´ÐµÐ»Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿ÑÐ°Ð²Ð¸Ð»Ð¾ Ð±ÐµÐ· modelId (Â«Ð½Ð° Ð²ÑÑ Ð¼Ð°ÑÐºÑÂ») Ð² Ð´ÐµÑÐµÐ²Ðµ Ð½Ðµ Ð¿Ð¾ÑÐ²Ð¸ÑÑÑ.
// Ð¢Ð°ÐºÐ¸Ðµ Ð¿ÑÐ°Ð²Ð¸Ð»Ð° Ð·Ð°Ð²Ð¾Ð´ÑÑÑÑ ÑÐ¾Ð»ÑÐºÐ¾ SQL-ÑÐºÑÐ¸Ð¿ÑÐ¾Ð¼, Ð½Ð¾ ÑÐ°Ð· Ð¾Ð½Ð¸ ÐµÑÑÑ â ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ Ð½Ðµ
// Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð¸Ñ Ð¼Ð¾Ð»ÑÐ° ÑÐ´Ð°Ð»ÑÑÑ, Ð²ÐµÐ´Ñ Ð¾Ð½Ð¾ Ð·Ð°Ð¼ÐµÐ½ÑÐµÑ Ð½Ð°Ð±Ð¾Ñ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼.
// ÐÑÐ°Ð²Ð¸Ð»Ð° Ñ Ð¼Ð¾Ð´ÐµÐ»ÑÑ ÑÑÐ´Ð° Ð½Ðµ Ð¿Ð¾Ð¿Ð°Ð´Ð°ÑÑ: Ð¸Ñ Ð´ÐµÑÐµÐ²Ð¾ ÑÑÑÐ¾Ð¸Ñ Ð¸Ð· ÑÑÐ¾ÐºÐ° Ð Ð¸Ð· Ð¿ÑÐ°Ð²Ð¸Ð»,
// Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾Ð½Ð¸ Ð²ÑÐµÐ³Ð´Ð° Ð¿ÑÐµÐ´ÑÑÐ°Ð²Ð¸Ð¼Ñ, Ð¸ ÑÐ´Ð°Ð»ÐµÐ½Ð¸Ðµ Ð²ÐµÑÐºÐ¸ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ¾Ð¼ Ð¾ÑÑÐ°ÑÑÑÑ ÑÐ´Ð°Ð»ÐµÐ½Ð¸ÐµÐ¼.
export const unrepresentableRules = (rules) =>
  rules.filter((r) => r.modelId === null || r.modelId === undefined);

// ÐÐ¾ÐºÑÑÑÐ¸Ðµ: ÑÐµÐ½Ð° Ð½Ð°ÑÐ»ÐµÐ´ÑÐµÑÑÑ Ð²Ð½Ð¸Ð·, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÑÐ¸ÑÐ°ÐµÐ¼ Ð¿Ð¾ Ð»Ð¸ÑÑÑÑÐ¼.
// `inherited` â ÑÐµÐ½Ð°, Ð´Ð¾ÑÑÐ°Ð²ÑÐ°ÑÑÑ ÑÐ·Ð»Ñ Ð¾Ñ Ð¿ÑÐµÐ´ÐºÐ¾Ð²: Ð´Ð»Ñ ÐºÐ¾ÑÐ½ÐµÐ¹ ÐµÑ Ð½ÐµÑ, Ð° Ð´Ð»Ñ
// Ð¿Ð¾Ð´Ð´ÐµÑÐµÐ²Ð° Ð² ÑÐµÑÐµÐ´Ð¸Ð½Ðµ Ð´ÐµÑÐµÐ²Ð° Ð¾Ð½Ð° Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÐ½Ð°, Ð¸Ð½Ð°ÑÐµ Ð²ÐµÑÐºÐ° Ð±ÐµÐ· ÑÐ²Ð¾ÐµÐ¹ ÑÐµÐ½Ñ
// Ð²ÑÐ³Ð»ÑÐ´ÐµÐ»Ð° Ð±Ñ Ð½ÐµÐ¿Ð¾ÐºÑÑÑÐ¾Ð¹, ÑÐ¾ÑÑ ÑÐµÐ½Ð° Ð·Ð°Ð´Ð°Ð½Ð° Ð²ÑÑÐµ.
const walkStats = (n, inherited, acc) => {
  const price = n.price != null ? n.price : inherited;
  if (n.kids.length) {
    n.kids.forEach((k) => walkStats(k, price, acc));
    return;
  }
  n.groups.forEach((g) => {
    acc.total += g.count;
    if (price == null) return;
    acc.priced += g.count;
    // Ð¡ÑÐ¸ÑÐ°ÐµÐ¼ Ð¼Ð°ÑÐ¸Ð½Ñ, Ð° Ð½Ðµ Ð²ÐµÑÐºÐ¸: Ð¿Ð¾ min/max Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ ÑÐºÐ°Ð·Ð°ÑÑ ÑÐ¾Ð»ÑÐºÐ¾ Â«Ð²Ð½ÑÑÑÐ¸
    // Ð²ÐµÑÐºÐ¸ ÑÐ°Ð·Ð±ÑÐ¾ÑÂ», Ð¸ ÑÐ¸ÑÐ»Ð¾ ÑÐ°ÑÑÐ¾Ð´Ð¸Ð»Ð¾ÑÑ Ñ Ð¿ÑÐµÐ´Ð¿ÑÐ¾ÑÐ¼Ð¾ÑÑÐ¾Ð¼ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ
    let off = 0;
    Object.entries(g.prices || {}).forEach(([at, cnt]) => {
      if (Number(at) !== price) off += cnt;
    });
    acc.changing += off;
    // Ð£ Ð²ÐµÑÐºÐ¸ Ð¸Ð·Ð²ÐµÑÑÐ½Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð¾Ð±ÑÐµÐµ ÑÐ¸ÑÐ»Ð¾ Ð·Ð°Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÑ, Ð½Ðµ Ð¸Ñ ÑÐµÐ½Ñ, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ
    // Ð¾Ð³ÑÐ°Ð½Ð¸ÑÐ¸Ð²Ð°ÐµÐ¼ ÑÐ²ÐµÑÑÑ ÑÐ¸ÑÐ»Ð¾Ð¼ Ð¼Ð°ÑÐ¸Ð½, ÐºÐ¾ÑÐ¾ÑÑÐµ Ð²Ð¾Ð¾Ð±ÑÐµ ÑÐ°ÑÑÐ¾Ð´ÑÑÑÑ Ñ Ð¿ÑÐ°Ð¹ÑÐ¾Ð¼
    if (off) acc.locked += Math.min(g.locked || 0, off);
  });
};

const finish = (acc) => ({ ...acc, withoutPrice: acc.total - acc.priced });
const zero = () => ({ total: 0, priced: 0, changing: 0, locked: 0 });

export const coverage = (roots) => {
  const acc = zero();
  roots.forEach((n) => walkStats(n, null, acc));
  return finish(acc);
};

// Ð¢Ð¾ Ð¶Ðµ ÑÐ°Ð¼Ð¾Ðµ, Ð½Ð¾ Ð¿Ð¾ Ð¾Ð´Ð½Ð¾Ð¹ Ð²ÐµÑÐºÐµ â Ð´Ð»Ñ Ð·Ð½Ð°ÑÐºÐ¾Ð² Ð½Ð° ÑÐ²ÑÑÐ½ÑÑÐ¾Ð¹ ÑÑÑÐ¾ÐºÐµ: ÑÐºÐ¾Ð»ÑÐºÐ¾
// Ð²Ð½ÑÑÑÐ¸ Ð¼Ð°ÑÐ¸Ð½ Ð±ÐµÐ· ÑÐµÐ½Ñ Ð¸ ÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐ°ÑÑÐ¾Ð´Ð¸ÑÑÑ Ñ Ð¿ÑÐ°Ð¹ÑÐ¾Ð¼, Ð½Ðµ ÑÐ°Ð·Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°Ñ ÐµÑ
export const subtreeStats = (node, inherited = null) => {
  const acc = zero();
  walkStats(node, inherited, acc);
  return finish(acc);
};

export const updateNode = (roots, target, patch) => {
  const walk = (n) =>
    n === target ? patch(n) : { ...n, kids: n.kids.map(walk) };
  return roots.map(walk);
};
